<script setup lang="ts">
import { MetricType, Type } from './utility';
import ValueTile from './parts/ValueTile.vue';

const props = defineProps<{
  title?: string;
  scores?: { value: number; label: string; metricType: MetricType }[];
  valueType?: Type;
  isLoadingIndicator?: boolean;
}>();

const { title, valueType } = toRefs(props);
</script>
<template>
  <ValueTile :loading="isLoadingIndicator" :title="title" :scores="scores" :type="valueType">
    <template #data="{ value }">
      <span class="text-[24px] xl:text-[32px]">{{ value }}</span>
    </template>
  </ValueTile>
</template>
